import { writeBatch } from 'firebase/firestore';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { _cacheGroupTypes } from 'global/cnr/contexts/useHelpers/useTimestamp';
import { createRefPath_event, createRefPath_events } from 'global/firestoreData/appData/appRefPaths';
import _ from 'lodash';
import { useCallback, useContext, useRef } from 'react';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { seasonalHelpers, seasonalUpdateTypes } from '../cnr/reducers/reducerHelpers/seasonalSportsData';
import { useSeasonalData, useSeasonals } from './useSeasonals';

export const _allowUpdates_sports = true

export const useCreateSeasonData = () => {

  const parentContext = useContext(ParentContext)
  const { fns, states } = parentContext ?? {}
  const { appUser_state, app_state, paps_state } = states ?? {}
  const { mainDb } = app_state ?? {}
  const { appUser } = appUser_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns

  const { sportsSeason_state } = SportsSeasonContext ?? {}
  const {
    currentSeason_info,
    links_score,
    matches_info,
    parentDataKeys,
    sportPermissions,
  } = sportsSeason_state ?? {}

  const { ammend_updateProps, ammend_updateNameProps } = useSeasonals()
  const { update_seasonalOrGlobal, getUpdateProps, getSports_collectionItem } = useSeasonalData()

  const datasToUpdateRef = useRef({
    seasonal: {},
    teams: {},
    matches: {}
  })

  const ammend_sportsSeasonalItem = useCallback((seasonal) => {
    datasToUpdateRef.current.seasonal = seasonal
    return seasonal
  }, [])

  const ammend_seasonalData = useCallback((payload) => {
    datasToUpdateRef.current.seasonal = payload
    return payload
  }, [])

  const ammend_sportsTeams = useCallback((teams) => {
    datasToUpdateRef.current.teams = teams
    return teams
  }, [])

  const ammend_sportsSeasonDataToUpdate = useCallback(
    ({ matches, seasonal, teams }) => {
      datasToUpdateRef.current = {
        matches,
        seasonal,
        teams
      }
      return datasToUpdateRef.current
    },
    []
  )

  const update_seasonSportsData = useCallback(
    ({ callback }) => {
      return updateSportsData(
        database_fns,
        mainDb,
        pathViews,
        datasToUpdateRef.current,
        '',
        appUser,
        callback
      )
    },
    []
  )

  const update_seasonalData = useCallback(async ({ opts, updateType }) => {
    const _opts = { ...opts, updateType, pathViews, appUser, sportPermissions }
    updateSeasonalUpdate({
      opts: _opts,
      update_seasonalOrGlobal,
      getSports_collectionItem,
      getUpdateProps,
      ammend_updateProps,
      ammend_updateNameProps,
      database_fns,
      mainDb,
    })
    return { updateSeasonalUpdate }
  }, []);


  const reset = useCallback(() => {
    datasToUpdateRef.current = {
      seasonal: {},
      teams: {},
      matches: {}
    }
  }, [])

  return {
    ammend_seasonalData,
    ammend_sportsTeams,
    ammend_sportsSeasonalItem,
    ammend_sportsSeasonDataToUpdate,
    update_seasonSportsData,
    update_seasonalData,
    reset,
    datasToUpdate: datasToUpdateRef.current
  }
}

const updateSportsData = async (
  database_fns,
  mainDb,
  pathViews,
  datasToUpdate,
  seasonalKey,
  appUser,
  callback,
) => {
  const { displayName, uid } = appUser ?? {}
  const _timestamp = getNow()

  const status = {
    uid,
    displayName,
    appVersion: _appVersion,
    lastUpdate: _timestamp
  }

  const allows = {
    matches_seasonal: !_.isEmpty(datasToUpdate?.matches_seasonal),
    seasonals: !_.isEmpty(datasToUpdate?.seasonals),
    teams_seasonal: !_.isEmpty(datasToUpdate?.teams_seasonal)
  }

  const paths = {
    matches_seasonal: allows.matches_seasonal && createRefPath_events(pathViews, ['_matches_seasonal']),
    seasonals: allows.seasonals && createRefPath_events(pathViews, ['_seasonals']),
    teams_seasonal: allows.views && createRefPath_events(pathViews, ['_teams_seasonal'])
  };

  const batch = writeBatch(mainDb);

  // (refPath, data, callback, batch, appUserAccess, storagePaths, vit) => fs_update_doc(mainDb, refPath, data, callback, batch, appUserAccess, storagePaths, vit)
  if (allows.matches_seasonal && paths.matches_seasonal) {
    database_fns.update_doc(paths.matches_seasonal, datasToUpdate.matches_seasonal, null, batch);
  }
  if (allows.seasonals && paths.seasonals) {
    database_fns.update_doc(paths.seasonals, datasToUpdate.seasonals, null, batch);
  }
  if (allows.views && paths.views) {
    database_fns.update_doc(paths.views, datasToUpdate.teams_seasonal, null, batch);
  }

  console.group('updateSettings_updatesOnly', baseRef)
  console.log('datasToUpdate', datasToUpdate)
  console.log('paths', paths)
  console.log('status', status)

  _.forEach(batch?._mutations, (m) => {
    if (m?.key?.path?.segments) {
      console.log('segments', m?.key?.path?.segments)
    }
  })

  console.groupEnd()

  if (_allowUpdates_sports) {
    database_fns.update_timestamp(_cacheGroupTypes.sportsSeason, seasonalKey, _timestamp, batch)
    batch.commit();
  }

  if (callback) {
    console.log('callback')
    callback();
  }

}

const ammendMatches = (matches) => {
  const _matches = _.groupBy(matches, '_matchCollectionKey')
  console.log('_matches', _matches)
}

const groupMatchesByCollectionKey = (matches) =>
  _.transform(
    matches,
    (acc, match, matchKey) => {
      const groupKey = match._matchCollectionKey;
      if (!groupKey) return;

      if (!acc[groupKey]) acc[groupKey] = {};
      acc[groupKey][matchKey] = match;
    },
    {}
  );


const updateSeasonalUpdate = async ({
  opts,
  getSports_collectionItem,
  database_fns,
  mainDb,
}) => {

  const {
    pathViews,
    selectedYear,
    sportsSeason_selected,
    sportsKey,
    _sportsAbr,
    callback,
    updateType
  } = opts ?? {}

  const {
    matches,
    teams: _teamz,
    seasonals: {
      details,
      sectionCounts,
      sectionDates,
      teams,
    },
    _sectionTeamCounts,
  } = sportsSeason_selected


  let sportCollectionName = ''

  switch (updateType) {
    case seasonalUpdateTypes.fullSeason_teams:
      sportCollectionName = '_teams_seasonal'
      break;
    case seasonalUpdateTypes.fullSeason_matches:
      sportCollectionName = '_matches_seasonal'
      break;
    default:
      sportCollectionName = '_seasonals'
  }

  const _sportsDocPrefix = `${_sportsAbr}_${selectedYear}`
  const _pks = seasonalHelpers.getPks(pathViews, selectedYear, sportsKey)
  const _sportsYearCollectionItem = await getSports_collectionItem(_pks, sportCollectionName, true)

  let _docKey;
  let _isNew = false;

  if (_sportsYearCollectionItem && !_.isEmpty(_sportsYearCollectionItem)) {
    const { _itemKey: sycKey } = _sportsYearCollectionItem
    _docKey = sycKey
  } else {
    _docKey = _sportsDocPrefix + '_' + database_fns.get_docKey()
    _isNew = true
  }

  let dataToUpdate;

  switch (updateType) {
    case seasonalUpdateTypes.fullSeason_teams:
      dataToUpdate = { teams: teams }
      break;

    case seasonalUpdateTypes.fullSeason_matches:
      dataToUpdate = {}
      break;

    case seasonalUpdateTypes.details:
      dataToUpdate = { details: details }
      break;
    case seasonalUpdateTypes.teams:
      dataToUpdate = { teams: teams }
      break;

    case seasonalUpdateTypes.sectionCrossovers:
      break;

    case seasonalUpdateTypes.sectionDates:
      dataToUpdate = { sectionDates: sectionDates }
      break;

    case seasonalUpdateTypes.matches:
      dataToUpdate = {
        matches: matches
      }
      break;
    default:
    // nothing
  }

  if (_isNew && dataToUpdate) {
    dataToUpdate.parentKeys = { ..._pks }
  }

  if (!dataToUpdate) {
    callback()
    return;
  }

  const batch = writeBatch(mainDb);

  const refPath = createRefPath_event(pathViews, [sportCollectionName, _docKey])

  console.clear()

  const paths = []

  if (refPath) {

    if (!_.isEmpty(dataToUpdate)) {
      database_fns.set_doc(refPath, dataToUpdate, true, false, batch);
      paths.push({
        path: refPath,
        data: dataToUpdate
      })
    }

    // subCollections
    switch (updateType) {
      case seasonalUpdateTypes.fullSeason_matches:
        if (matches) {
          const groupedMatches = groupMatchesByCollectionKey(matches)
          // each key is a document
          _.forEach(groupedMatches, (groupMatches, groupKey) => {
            const _subPath = createRefPath_event(pathViews, [sportCollectionName, _docKey, 'matches', groupKey]);
            paths.push({
              path: _subPath,
              matches: groupMatches
            })
            database_fns.set_doc(
              _subPath,
              { matches: groupMatches }, // only this group's matches
              false, // DO NOT MERGE, this is an overwrite
              false,
              batch
            );
          });
          console.log('groupedMatches', paths)
        }
        break;
      default:
      // nothing 
    }
  }

  console.group('updateSeasonalUpdate', updateType)
  console.log('paths', paths)
  console.log('dataToUpdate', dataToUpdate)
  console.groupEnd()

  if (_allowUpdates_sports) {
    batch.commit();
  }



  callback()

  // console.log('sportsSeason_selected', sportsSeason_selected)

  // const _updateProps = getUpdateProps(
  //   database_fns,
  //   sportPermissions,
  //   pathViews,
  //   null,
  //   null,
  //   null,
  //   null,
  //   null,
  //   null,
  //   null,
  //   _sportsYearAbr
  // )

  // _updateProps.database_fns = database_fns
  // _updateProps._sportsAbr = _sportsAbr
  // _updateProps._seasonalKey = _seasonalKey
  // _updateProps.teams = teams

  // const cb0 = (result) => {
  //   const response_data = { success: true }
  //   handleStopUpdate(response_data, dispatch)
  // }

  // // const {
  // //   matches,
  // //   teams: _teamz,
  // //   seasonals: {
  // //     details,
  // //     playoffQualifyCounts: _playoffQualifyCounts,
  // //     sectionCrossovers: _sectionCrossovers,
  // //     sectionDates: _sectionDates,
  // //     crossSectionDates: _crossSectionDates,
  // //     teams: _teamsWithSections,
  // //   },
  // //   _sectionTeamCounts,
  // // } = sportsSeason_selected

  // if (_teamsWithSections) {
  //   Object.keys(_teamsWithSections).forEach(k => {
  //     delete _teamsWithSections[k].record
  //     delete _teamsWithSections[k].parentKeys
  //   })
  // }

  // // if (currentMatches) {
  // //   Object.keys(currentMatches).forEach(cmk => {
  // //     if (!currentMatches[cmk]._status) { currentMatches[cmk]._status = {} }
  // //     if (!currentMatches[cmk]._status.setsToWin) { currentMatches[cmk]._status.setsToWin = 3 }
  // //     if (!currentMatches[cmk]._status.setCount) { currentMatches[cmk]._status.setCount = 5 }
  // //     delete currentMatches[cmk]._itemKey
  // //   })
  // // }

  // const _pks = seasonalHelpers.getPks(pathViews, selectedYear, sportsKey)
  // const _pksValid = seasonalHelpers.isValidPks(_pks)

  // ammend_updateProps(_updateProps, _pks, cb0)
  // let _details = dataFix.removeEmpties(details)
  // _details = dataFix.removeUnderscoreKeys(_details, [..._deleteItemProps])

  // // this will NOT update unless it has a valid pks
  // if (_pksValid) {
  //   switch (updateType) {

  //     case seasonalUpdateTypes.details:
  //       // _seasonals
  //       ammend_updateNameProps(_updateProps, null, 'details', _details)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.details, _updateProps)

  //       ammend_updateNameProps(_updateProps, null, 'playoffQualifyCounts', _playoffQualifyCounts)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.details, _updateProps)
  //       break;

  //     case seasonalUpdateTypes.sectionCrossovers:
  //       // _seasonals
  //       ammend_updateNameProps(_updateProps, null, 'sectionCrossovers', _sectionCrossovers)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.sectionCrossovers, _updateProps)
  //       break;

  //     case seasonalUpdateTypes.playoffQualifyCounts:
  //       // _seasonals
  //       ammend_updateNameProps(_updateProps, null, 'playoffQualifyCounts', _playoffQualifyCounts)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.details, _updateProps)
  //       break;

  //     case seasonalUpdateTypes.teams:
  //       // _seasonals
  //       ammend_updateNameProps(_updateProps, null, 'teams', _teamsWithSections)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.teams, _updateProps)
  //       break;

  //     case seasonalUpdateTypes.sectionDates:
  //       // _seasonals(parentKeys)/sectionDates
  //       // _seasonals
  //       ammend_updateNameProps(_updateProps, null, 'sectionDates', _sectionDates)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.sectionDates, _updateProps)

  //       if (_crossSectionDates) {
  //         const _updateProps2 = _.cloneDeep(_updateProps)
  //         ammend_updateNameProps(_updateProps2, null, 'crossSectionDates', _crossSectionDates)
  //         update_seasonalOrGlobal(seasonalUpdateTypes.sectionDates, _updateProps2)
  //       }
  //       break;

  //     case seasonalUpdateTypes.results:
  //       ammend_updateNameProps(_updateProps, 'matches', 'matches', seasonMatches, { subCollectionName: 'matches', useLevelSeparation: true })
  //       update_seasonalOrGlobal(seasonalUpdateTypes.matchesCreate, _updateProps)
  //       break;

  //     case seasonalUpdateTypes.resultsPlayoff:
  //       ammend_updateNameProps(_updateProps, 'playoffMatches', 'playoffMatches', seasonPlayoffMatches, { subCollectionName: 'playoffMatches', useLevelSeparation: true })
  //       update_seasonalOrGlobal(seasonalUpdateTypes.matchesCreate, _updateProps)
  //       break;

  //     case seasonalUpdateTypes.matches:
  //       ammend_updateNameProps(_updateProps, null, 'matches', matches)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps)
  //       break;

  //     case seasonalUpdateTypes.fullSeason:
  //       ammend_updateNameProps(_updateProps, 'teams_seasonal', 'teams', _teamsWithSections)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.teams, _updateProps)

  //       const _updateProps2 = _.cloneDeep(_updateProps)
  //       ammend_updateNameProps(_updateProps2, 'matches', 'matches', currentMatches, { subCollectionName: 'matches' })
  //       update_seasonalOrGlobal(seasonalUpdateTypes.matchesCreate, _updateProps2)
  //       break

  //     case seasonalUpdateTypes.fullSeason_matches:
  //       const _updateProps3 = _.cloneDeep(_updateProps)
  //       ammend_updateNameProps(_updateProps3, 'matches', 'matches', seasonMatches, { subCollectionName: 'matches' })
  //       update_seasonalOrGlobal(seasonalUpdateTypes.matchesCreate, _updateProps3)
  //       break

  //     case seasonalUpdateTypes.fullSeason_teams:
  //       ammend_updateNameProps(_updateProps, 'teams_seasonal', 'teams', _teamsWithSections)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.teams, _updateProps)
  //       break

  //     // case seasonalUpdateSteps.seasonSectionAlignment:
  //     //   // _seasonals(parentKeys)/teams
  //     //   seasonalHelpers.ammendUpdateNameProps(_updateProps, null, 'teams', _teamsWithSections)
  //     //   seasonalHelpers.updateSeasonalOrGlobal(seasonalUpdateTypes.teams, _updateProps)
  //     //   break;

  //     // case seasonalUpdateSteps.seasonTeams:
  //     //   // _seasonals(parentKeys)/teams
  //     //   // const _teamsObj = convertHelpers.createObjectFromArray(_teamz_selected)
  //     //   const _data_teams = dataFix.removeAllKeys(_teamsObj, ['checked', 'disabled', 'key', '_itemKey', '_teamKey'])
  //     //   seasonalHelpers.ammendUpdateNameProps(_updateProps, null, 'teams', _data_teams)
  //     //   seasonalHelpers.updateSeasonalOrGlobal(seasonalUpdateTypes.teams, _updateProps)
  //     //   break;

  //     // case seasonalUpdateSteps.seasonSectionTeams:
  //     //   // _seasonals(parentKeys)/teams
  //     //   // seasonalHelpers.ammendUpdateNameProps(_updateProps, 'backup_matches', 'matches', currentMatches)
  //     //   seasonalHelpers.ammendUpdateNameProps(_updateProps, null, 'teams', _teamz)
  //     //   seasonalHelpers.updateSeasonalOrGlobal(seasonalUpdateTypes.teams, _updateProps)
  //     //   break;

  //     // case seasonalUpdateSteps.seasonDetails:
  //     // case seasonalUpdateSteps.year:
  //     //   delete details._deleteProps
  //     //   // _seasonals(parentKeys)/details 
  //     //   seasonalHelpers.ammendUpdateNameProps(_updateProps, null, 'details', details)
  //     //   seasonalHelpers.updateSeasonalOrGlobal(seasonalUpdateTypes.details, _updateProps)
  //     //   break;

  //     case seasonalUpdateSteps.seasonSectionCount:
  //       // _seasonals(parentKeys)/sectionCounts
  //       ammend_updateNameProps(_updateProps, null, 'sectionCounts', _sectionTeamCounts)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.sectionCounts, _updateProps)
  //       break;

  //     case seasonalUpdateSteps.seasonCrossovers:
  //       // _seasonals(parentKeys)/seasonCrossovers
  //       ammend_updateNameProps(_updateProps, null, 'sectionCrossovers', _sectionCrossovers)
  //       update_seasonalOrGlobal(seasonalUpdateTypes.sectionCrossovers, _updateProps)
  //       break;

  //     default:
  //     // nothing
  //   }
  // }

}


const xxxx = () => {
  return {
    _matches_seasonal: {
      docKey: {
        parentKeys: {
          districts: 'districtsKey',
          organizations: 'organizationsKey',
          sports: 'sportsKey',
          sportsYears: 'sportsYears',
        },
        matches: {
          ['1A']: {
            matches: {}
          }
        },
        playoffMatches: {}
      }
    },
    _seasonals: {
      ['_seasonalsKey']: {
        parentKeys: {
          districts: 'districtsKey',
          organizations: 'organizationsKey',
          sports: 'sportsKey',
          sportsYears: 'sportsYears',
        },
        details: {},
        playoffQualifyCounts: {},
        sectionCounts: {},
        sectionDates: {},
        teams: {}
      },
      _teams_seasonal: {
        ['_teams_seasonalKey']: {
          parentKeys: {
            districts: 'districtsKey',
            organizations: 'organizationsKey',
            sports: 'sportsKey',
            sportsYears: 'sportsYears',
          },
          teams: {}
        }
      }

    }
  }

}
